import { render, staticRenderFns } from "./detail-expired-activity.vue?vue&type=template&id=7af33c30&scoped=true&"
import script from "./detail-expired-activity.vue?vue&type=script&lang=js&"
export * from "./detail-expired-activity.vue?vue&type=script&lang=js&"
import style0 from "./detail-expired-activity.vue?vue&type=style&index=0&id=7af33c30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af33c30",
  null
  
)

export default component.exports